class TicketTypeController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'$uibModal'
		'parseBool'
		'ticketType'
		'ticketEvents'
		'priceRegions'
		'vatRates'
		'productCategoriesList'
		'Guid'
		'HelperRepository'
		'TicketTypeRepository'
		'ShopRepository'
		'ShopGroupRepository'
		'ProductCategoryRepository'
		'TicketEventSessionOverrideRepository'
		'ProductRepository'
		'ProductService'
		'MessageTerminal'
		'ConfigurationService'
		'EntityAttributeService'
		'CopyService'
		'ACCOUNTING_CATEGORIES'
		'BACKEND_PRODUCT_ENTITY_TYPE'
		'BACKEND_PRODUCT_DATA_ENTITY_TYPE'
		'BACKEND_SHOP_GROUP_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.ticket_type'
		@mainCrud.entityTitle = 'general.new.ticket_type'
		@accountingCategoriesLoaded = true
		@namePlaceholder = null
		@showIntervalSelection = true
		@sessionOverrides = null

		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@accountingCategoriesEnabled = @ConfigurationService.isEnabled 'Shared.Setting.AccountingCategories.Enabled'
		@shopGroupsEnabled = @ConfigurationService.isEnabled "Backoffice.ShopManagement.Shops.EnableShopGroups"
		@variantsEnabled = @ConfigurationService.isEnabled 'Backoffice.ProductManagement.Products.EnableProductVariantCreation'
		@isVatRateEnabled = @ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'
		@hasPriceRegion = false
		@customExpireInterval = false
		@selectedExpireInterval = null

		@expireIntervals = {
			"#{60 * 60}": @$filter('translate')('general.time.hour')
			"#{60 * 60 * 24}": @$filter('translate')('general.time.day')
			"#{60 * 60 * 24 * 7}": @$filter('translate')('general.time.week')
			"#{60 * 60 * 24 * 30}": @$filter('translate')('general.time.month')
			"#{60 * 60 * 24 * 182}": @$filter('translate')('general.time.half_year')
			"#{60 * 60 * 24 * 365}": @$filter('translate')('general.time.year')
			"-1": '- ' + @$filter('translate')('general.ticket_type.expire_interval.custom') + ' -'
		}

		@expirePeriods = {
			"tomorrow": @$filter('translate')('general.period.same_day')
			"next monday": @$filter('translate')('general.period.same_week')
			"first day of +1 month midnight": @$filter('translate')('general.period.same_month')
			"+1 year January 1": @$filter('translate')('general.period.same_year')
			"-1": '- ' + @$filter('translate')('general.ticket_type.expire_interval.custom') + ' -'
		}

		if @ticketType.id?
			@mainCrud.entityTitle = @ticketType.product.name
			@mainCrud.isNewEntity = false
			@ticketType.allow_all_sessions = @parseBool(@ticketType.allow_all_sessions)

			if @ticketType.expire_period?
				@showIntervalSelection = false

			if !_.isEmpty @ticketType.product.product_categories
				for category in @ticketType.product.product_categories
					productCategory = _.find(@productCategoriesList, {id: category.id})

					category.path = if productCategory? then productCategory.path else category.name
		else
			id = @Guid.generate()
			@ticketType =
				id: id
				expire_interval: null
				ticket_event_id: null
				allow_all_sessions: false
				product:
					id: id
					active: true
					entity_type: @BACKEND_PRODUCT_ENTITY_TYPE.TICKET
					max_quantity_per_line_item: '1'
					offline_product: '0'
					product_data: [
						entity_type: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
						price_region_id: @priceRegions[0].id
						variable_price: false
						cost_price: 0
						retail_price: 0
					]

		@newVariant = @getNewProductVariant()
		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity(
			@ticketType.product,
			'BACKEND_PRODUCT_ATTRIBUTE_TYPE',
			{
				exclude_from_ordering_suggestion: '1'
				hide_from_web: '0'
				requires_preparation: '0'
				age_restriction: null
				block_in_self_checkout: '0'
			}
		)

		if @accountingCategoriesEnabled
			@initAccountingCategories()

		@mainCrud.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'wbo.tab.pricing'
				selector: '#tab-pricing'
			}
		]

		@initExpireInterval()
		@onExpireIntervalChange()
		@initPriceRegionSelector()

	onExpireIntervalChange: ->
		@sampleDate = null

		if @selectedExpireInterval == '-1'
			@customExpireInterval = true
		else
			@customExpireInterval = false

	openSessionOverrideModal: ->
		@$uibModal
			.open
				templateUrl: '@app/ticket-type/modals/ticket-type.session-override.modal.view.html'
				bindToController: true
				controllerAs: 'overrideModal'
				controller: 'TicketTypeSessionOverrideModalController'
				resolve:
					sessions: (TicketEventSessionRepository) =>
						query = TicketEventSessionRepository.createQuery()
						query.criteria('ticket_event_id', '=', @ticketType.ticket_event_id)
						query
							.criteria('session_overrides.ticket_type_id', '=', @ticketType.id)
							.or('session_overrides.ticket_type_id', 'IS', 'NULL')
						query.with 'session_overrides'

						return TicketEventSessionRepository.getEntities(query)
			.result
			.then (overrides) =>
				@mainCrud.parent_form.$setDirty()
				@sessionOverrides = overrides

	save: ->
		ticketEvent = @getEntityCopy()

		@TicketTypeRepository
			.saveWithAttachment ticketEvent, @mainCrud.isNewEntity
			.then (response) =>
				if !_.isEmpty(@sessionOverrides)
					@saveTicketEventSessionOverrides(response.data.id)

				@afterSave(response)
			.catch (response) =>
				@handleErrors response

	saveTicketEventSessionOverrides: (ticketTypeId) ->
		for override in @sessionOverrides
			override.ticket_type_id = ticketTypeId

			# @TODO: This will cause issues if we add more fields to overrides. Works fine now
			#
			# No value and has ID - remove existing record
			if !override.max_tickets_count? && override.id
				@TicketEventSessionOverrideRepository.delete(override.id)

				continue

			@TicketEventSessionOverrideRepository.save(override)

	getEntityCopy: ->
		@attributesService.persistAttributes()

		if @showIntervalSelection
			@ticketType.expire_period = null

			if @selectedExpireInterval != '-1'
				@ticketType.expire_interval = @selectedExpireInterval
		else
			@ticketType.expire_interval = null

			if @selectedExpireInterval != '-1'
				@ticketType.expire_period = @selectedExpireInterval

		if !_.isEmpty @ticketType.product.product_variants
			for variant in @ticketType.product.product_variants
				delete variant.is_new

		image = @ticketType.product.image
		ticketType = @CopyService.copy @ticketType
		delete ticketType.product.image
		delete ticketType.event

		# @TODO: Yii treats multi-part value as string<false> instead of boolean<false>
		ticketType.allow_all_sessions = if ticketType.allow_all_sessions then '1' else '0'
		ticketType.image = image if image?
		ticketType.product.name = @getSelectedEventName() if _.isEmpty ticketType.product.name
		ticketType.name = ticketType.product.name
		ticketType.product.product_categories = _.pluck(@ticketType.product.product_categories, 'id')
		ticketType.product.shops = _.pluck(@ticketType.product.shops, 'id')
		ticketType.product.shop_groups = _.pluck(@ticketType.product.shop_groups, 'id')

		return ticketType

	delete: ->
		@deleteEntity(@TicketTypeRepository, @ticketType)

	# Accounting categories implementation (mostly for Norway users)
	initAccountingCategories: ->
		@accountingCategoriesLoaded = true

		categoryId = @attributesService.attributes.accounting_category_id

		if angular.isDefined categoryId
			@accountingCategory = _.find(@ACCOUNTING_CATEGORIES.DATA, {id: categoryId.value})
		else
			@accountingCategory = _.find(@ACCOUNTING_CATEGORIES.DATA, {id: @ACCOUNTING_CATEGORIES.DEFAULT.TICKETS})

		@setAccountingCategory()

	setAccountingCategory: ->
		@attributesService.setAttribute 'accounting_category_id', @accountingCategory.id
		@attributesService.setAttribute 'accounting_category_name', @accountingCategory.name

	findShops: (name) ->
		@ShopRepository.searchShops name

	findShopGroups: (searchString) ->
		query = @ShopGroupRepository.createQuery()
		query.criteria 'name', 'LIKE', searchString
		query.criteria 'entity_type', '=', @BACKEND_SHOP_GROUP_ENTITY_TYPE.PRODUCT_SHOP_GROUP

		@ShopGroupRepository.findByQuery query

	findCategories: (name) ->
		@ProductCategoryRepository.searchCategories name

	onEventChange: ->
		@namePlaceholder = @getSelectedEventName()

	onIntervalSelectorChange: ->
		@selectedExpireInterval = null
		@customExpireInterval = false
		@ticketType.expire_period = null
		@ticketType.expire_interval = null

	onCustomPeriodChange: ->
		@sampleDate = null
		@resetErrors()

		@HelperRepository
			.periodToTime @ticketType.expire_period
			.then (response) =>
				if !response.timestamp?
					@addErrorMessage 'expire_period', @$filter('translate')('general.error.invalid_period')

					return

				@sampleDate = response.date
			.catch (response) =>
				@handleErrors response, @mainCrud.entityTitle

	getSelectedEventName: ->
		return _.find(@ticketEvents, {id: @ticketType.ticket_event_id})?.name

	initExpireInterval: ->
		if @ticketType.expire_interval?
			@ticketType.expire_period = null

			if angular.isDefined(@expireIntervals[@ticketType.expire_interval])
				@selectedExpireInterval = @ticketType.expire_interval
			else
				@selectedExpireInterval = '-1'
		else if @ticketType.expire_period?
			@ticketType.expire_interval = null

			if angular.isDefined(@expirePeriods[@ticketType.expire_period])
				@selectedExpireInterval = @ticketType.expire_period
			else
				@selectedExpireInterval = '-1'

	initPriceRegionSelector: ->
		productData = _.property(['product', 'product_data'])(@ticketType)

		selectedPriceRegion = @ProductService.getPriceRegion @priceRegions, productData

		@hasPriceRegion = angular.isDefined(selectedPriceRegion)

		if @hasPriceRegion
			@selectPriceRegion(selectedPriceRegion.id)

	###
	 Assign changed value to selected price region
	 Change default pricing and vat rate
	###
	selectPriceRegion: (priceRegionId) ->
		updateVariantsPriceRegion = =>
			@newVariant.product_data[0].price_region_id = priceRegionId

			if !_.isEmpty @ticketType.product.product_variants
				for variant in @ticketType.product.product_variants
					variant.product_data[0].price_region_id = priceRegionId

		@selectedPriceRegion = _.find(@priceRegions, {id: priceRegionId})
		@ticketType.product.product_data = [
			@ProductService.getDefaultProductData(@ticketType.product.product_data, @selectedPriceRegion)
		]

		updateVariantsPriceRegion()

	addVariant: ->
		@ticketType.product.product_variants ?= []
		@ticketType.product.product_variants.push @newVariant

		@newVariant = @getNewProductVariant()

		@newVariantForm.$setPristine()
		@mainCrud.parent_form.$setDirty true

	removeVariant: (variant) ->
		@ticketType.product.product_variants = _.reject(@ticketType.product.product_variants, {id: variant.id})
		@mainCrud.parent_form.$setDirty true

	getNewProductVariant: ->
		return {
			is_new: true
			id: @Guid.generate()
			product_variant_name: null
			product_id: @ticketType.product.id
			product_data: [
				{
					price_region_id: @ticketType.product.product_data[0].price_region_id
					entity_type: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
					variable_price: false
				}
			]
		}
